import {
  JourneyInterface,
  QuestInterface,
  QuestType,
  RoleInterface,
  RoleInterfaceMap,
  Slug,
} from '@swivl-mono/types';
import { APIService } from '../Service/API.Service';

export class JourneysAPI {

  static async getBySlug(orgId: number, slug: Slug) {
    return APIService.Server.get<JourneyInterface>(
      `/journeys/org/${orgId}/slug/${slug}`
    );
  }
  static async updateJourneys(orgId: number, journeys: Partial<JourneyInterface>[]) {
    return APIService.Server.put<JourneyInterface[]>(
      `/journeys/org/${orgId}`,
      journeys
    );
  }

  static async createJourney(orgId: number, journey: Partial<JourneyInterface>) {
    return APIService.Server.post<JourneyInterface>(
      `/journeys/org/${orgId}`,
      journey
    );
  }
   static async deleteJourney(orgId: number, journeyId: number) {
    return APIService.Server.post<boolean>(
      `/journeys/org/${orgId}/journey/${journeyId}`
    );
  }

}
